import isUuid from 'is-uuid';
import { FormSectionHandler } from '../entity.handler';
import { HealthIssueResponse } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils } from '../utils';
import { ICONS } from '../icons';
import { HealthIssueService, ContextualizedHealthIssue } from './healthissue.service';

interface EditorValues {
    target?: string;
    topic?: string;
    description?: string;
    remedy?: string;
    count?: number;
    source?: string;
    state?: string;
    created?: string;
    updated?: string;
}

export class HealthIssueDetailsSectionHandler implements FormSectionHandler<HealthIssueResponse, EditorValues> {

    type = 'form';
    icon = ICONS.systemhealth;
    bulk = false;
    readonly = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    actions = [{ id: 'resolve', name: this.admin.translate('EDITORS.HEALTHISSUE.DETAILS.FIELDS.RESOLVE'), showAlways: true }];

    constructor(
        public admin: AdminEditorService,
        public readonly service: HealthIssueService,
        public ownerId: string
    ) {
    }


    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.HEALTHISSUE.DETAILS.${key}`, values);
    }

    async applyUpdate(_entity: HealthIssueResponse, _payload: any): Promise<HealthIssueResponse> {
        throw new Error('not implemented');
    }

    async mapEntityToEditor(entity: ContextualizedHealthIssue): Promise<EditorValues> {
        return {
            target: entity.targetName,
            topic: entity.title,
            description: entity.description,
            remedy: entity.remedy,
            count: entity.count,
            source: entity.sourceName,
            state: this.translate(`FIELDS.STATE.${entity.resolved ? 'RESOLVED' : 'UNRESOLVED'}`),
            created: entity.date.created,
            updated: entity.date.updated,
        };

    }

    async mapEditorToEntity(_entity: any, _values: EditorValues): Promise<any> {
        return {}; // editing not implemented
    }

    async getFields(entity: HealthIssueResponse): Promise<FormBuilderField[]> {
        const fields = [
            {
                ...TextField('target', this.translate('FIELDS.ENTITY'), true, 1, 255),
                getHref: (_field: FormBuilderField, _values: any) => {
                    return entity.target && isUuid.anyNonNil(entity.target.id) ? `/admin/client/${entity.owner.id}/${entity.target.type}s/grid/${entity.target.type}/${entity.target.id}` : null;
                },
            },
            {
                ...TextField('source', this.translate('FIELDS.SOURCE'), true, 1, 255),
                getHref: (_field: FormBuilderField, _values: any) => {
                    return entity.source && isUuid.anyNonNil(entity.source.id)     ? `/admin/client/${entity.owner.id}/${entity.source.type}s/grid/${entity.source.type}/${entity.source.id}` : null;
                },
            },
            TextField('topic', this.translate('FIELDS.TOPIC'), true, 1, 255),
            TextField('description', this.translate('FIELDS.DESCRIPTION'), true, 1, 255),
            TextField('remedy', this.translate('FIELDS.REMEDY'), true, 1, 255),
            TextField('count', this.translate('FIELDS.COUNT'), true, 1, 255),
            TextField('state', this.translate('FIELDS.STATE.TITLE'), true, 1, 255),
            TextField('created', this.translate('FIELDS.CREATED'), true, 1, 1024),
            TextField('updated', this.translate('FIELDS.UPDATED'), true, 1, 1024),
        ];
        return EntityUtils.prepareBulk(!entity, [], fields);
    }

    async actionTriggered(entity: HealthIssueResponse, action: string): Promise<void> {
        switch (action) {
            case 'resolve':
                await this.admin.applyUpdate(api => api.health.updateIssue(entity.id, { resolved: { message: 'Resolved' } }));
        }
    }

}
